const state = {
  photo: ''
}
const getters = {
  getPhoto (state) {
    return state.photo
  }
}
const actions = {}
const mutations = {
  setPhoto (state, photo) {
    console.log('state')
    state.photo = photo
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shangtang/index.js